import React, { useEffect } from "react";
import tw from "twin.macro";

//const WidgetWrapper = tw.div`w-full max-w-lg p-0 bg-white rounded shadow`;
//const WidgetWrapper = tw.div`w-full max-w-6xl bg-white rounded shadow`;


//const WidgetWrapper = tw.div`flex-col items-center w-full justify-center min-h-[60vh] max-w-lg bg-gray-100`;
const WidgetWrapper = tw.div`w-full flex-col justify-center items-center max-w-full bg-white rounded shadow`;

const BookingWidgetContainer = tw.div`
  flex flex-col items-center justify-center min-h-[60vh] w-full bg-gray-100 px-6 py-4
`;

const CheckfrontBookingWidget = () => {
  useEffect(() => {
    // Load the external Checkfront script
    const script = document.createElement("script");
    script.src = "//toronto-harbour-water-taxi.checkfront.com/lib/interface--0.js";
    script.type = "text/javascript";
    script.onload = () => {
      // Initialize the widget when script loads
      if (window.DROPLET && window.DROPLET.Widget) {
        new window.DROPLET.Widget({
          host: 'toronto-harbour-water-taxi.checkfront.com',
          target: 'CHECKFRONT_WIDGET_01',
          item_id: '2',
          category_id: '2',
          options: 'tabs,hidedates',
          provider: 'droplet'
        }).render();
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
      <WidgetWrapper>
        <div id="CHECKFRONT_WIDGET_01">
          <p
            id="CHECKFRONT_LOADER"
            style={{
              background: `url('//toronto-harbour-water-taxi.checkfront.com/images/loader.gif') left center no-repeat`,
              padding: '5px 5px 5px 20px',
            }}
          >
            Searching Availability...
          </p>
        </div>
        <noscript>
          <a
            href="https://toronto-harbour-water-taxi.checkfront.com/reserve/"
            style={{ fontSize: '16px' }}
          >
            Continue to Secure Booking System &raquo;
          </a>
        </noscript>
      </WidgetWrapper>

  );
};

export default CheckfrontBookingWidget;
